import { dialApiFetch, isDialApiConfigured } from './client';

export interface LeaderEntry {
  user_id: string;
  label: string;
  count: number;
}

export interface ConnectRateRow {
  user_id: string;
  label: string;
  dials: number;
  conversations: number;
  rate_pct: number;
}

export interface DashboardData {
  generated_at: string;
  telesales_today: { total: number; leaders: LeaderEntry[] };
  telesales_year: { total: number; last_year: number; yoy_pct: number | null };
  by_owner: { period: 'month' | 'year'; rows: LeaderEntry[] };
  by_purpose: { telesales: number; courtesy_call: number; vme: number };
  active_sprints: { sprint_count: number; contacts_being_worked: number };
  connect_rate: ConnectRateRow[];
  database_updates: { period: 'month' | 'year'; rows: LeaderEntry[] };
}

const EMPTY: DashboardData = {
  generated_at: new Date(0).toISOString(),
  telesales_today: { total: 0, leaders: [] },
  telesales_year: { total: 0, last_year: 0, yoy_pct: null },
  by_owner: { period: 'month', rows: [] },
  by_purpose: { telesales: 0, courtesy_call: 0, vme: 0 },
  active_sprints: { sprint_count: 0, contacts_being_worked: 0 },
  connect_rate: [],
  database_updates: { period: 'month', rows: [] },
};

export async function getDashboard(period: 'month' | 'year' = 'month'): Promise<DashboardData> {
  if (!isDialApiConfigured) return EMPTY;
  return dialApiFetch<DashboardData>(`/v1/dashboard?period=${period}`);
}

export const EMPTY_DASHBOARD = EMPTY;
